import React, { useRef, useEffect } from 'react';
import { MenuItem } from 'rc-menu';
import { TrevorIcon } from '@trevor/ui-components';
import { SEARCH_BAR_CLEAR_BUTTON } from '@/constants/test-ids';
import styles from './SearchBar.module.scss';
import { unifiedStopPropagation } from '../../../../util/unifiedStopPropagation';

const useLockParentContainerDimensions = () => {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (ref?.current?.parentNode?.parentNode) {
      const menuNode = ref.current.parentNode.parentNode as HTMLElement;
      const { width, height } = menuNode.getBoundingClientRect?.() ?? {};

      menuNode.style.width = `${width}px`;
      menuNode.style.height = `${height}px`;
    }
  }, []);

  return ref;
};

export type SearchBarProps = {
  value: string;
  onChange: (v: string) => void;
  autoFocus?: boolean;
};

export const SearchBar: React.FC<SearchBarProps> = ({
  value,
  onChange,
  autoFocus = false,
  ...props
}) => {
  const ref = useLockParentContainerDimensions();

  const handleOnChange = (e: React.ChangeEvent<HTMLInputElement>) =>
    onChange(e.target.value);

  const resetInput = () => onChange('');
  return (
    <MenuItem {...props} onClick={unifiedStopPropagation}>
      <div className={styles.searchBar} ref={ref}>
        <div className={styles.search}>
          <div className={styles.searchInner}>
            <div className={styles.searchIconContainer}>
              <TrevorIcon name="search" />
            </div>
            <input
              autoFocus={autoFocus}
              placeholder="Search"
              className={styles.searchInput}
              value={value}
              onChange={handleOnChange}
              role="searchbox"
            />
            <div className={styles.clearIcon}>
              {!!value.length && (
                <span
                  onClick={resetInput}
                  className={styles.clearSearch}
                  data-testid={SEARCH_BAR_CLEAR_BUTTON}
                >
                  <TrevorIcon name="close-circle" />
                </span>
              )}
            </div>
          </div>
        </div>
      </div>
    </MenuItem>
  );
};

SearchBar.displayName = 'SearchBar';
